import React, { useState, useEffect } from 'react';
import { onUpdateAvailable, offUpdateAvailable, skipWaiting } from '../utils/serviceWorkerRegistration';
import toast from 'react-hot-toast';

const ServiceWorkerUpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    const handleUpdateAvailable = () => {
      setShowUpdate(true);
      toast(
        (t) => (
          <div className="flex flex-col gap-2">
            <p className="font-medium">New version available!</p>
            <p className="text-sm text-gray-300">
              A new version of the app is available. Refresh to get the latest features.
            </p>
            <div className="flex gap-2 mt-2">
              <button
                onClick={() => {
                  skipWaiting();
                  toast.dismiss(t.id);
                }}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm font-medium transition-colors"
              >
                Refresh Now
              </button>
              <button
                onClick={() => {
                  setShowUpdate(false);
                  toast.dismiss(t.id);
                }}
                className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded text-sm font-medium transition-colors"
              >
                Later
              </button>
            </div>
          </div>
        ),
        {
          id: 'sw-update',
          duration: Infinity, // Don't auto-dismiss
          position: 'top-center',
          style: {
            background: '#1f2937',
            color: '#fff',
            padding: '16px',
            borderRadius: '8px',
            maxWidth: '400px',
          },
        }
      );
    };

    onUpdateAvailable(handleUpdateAvailable);

    return () => {
      offUpdateAvailable(handleUpdateAvailable);
    };
  }, []);

  return null; // This component doesn't render anything directly
};

export default ServiceWorkerUpdateNotification;

